<template>
  <div>
    <input
      type="checkbox"
      :name="name"
      :checked="localValue"
      @change="onChange"
      :class="['input-inline', { 'is-invalid': error }]"
    />
    <label>{{ label }}</label>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    value: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    // The root is a wrapper div, so this has to go on the checkbox itself.
    error: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: this.value !== undefined ? this.value : false
    };
  },
  watch: {
    value(newVal) {
      this.localValue = newVal !== undefined ? newVal : false;
    }
  },
  methods: {
    onChange(event) {
      this.localValue = event.target.checked;
      this.$emit('update:value', event.target.checked);
    }
  }
};
</script>

<style scoped>
.input-inline {
  margin-right: 5px;
}

/* Outline, not border: a checkbox's border is drawn by the native widget and
   ignored in most browsers, while an outline sits outside the box and shows. */
.is-invalid {
  outline: 2px solid red;
  outline-offset: 1px;
}
</style>
